import {
  backgroundImageLinearGradient,
  mq,
  paddingBottom,
  paddingV,
  stylesIfPropFalse,
  stylesIfPropTrue,
} from '@sleepstation/style-api-helpers'
import { constrainNarrow } from '@sleepstation/style-mixins'
import {
  defaultTheme,
  reversedAltTheme,
} from '@sleepstation/themes-public-site'
import PropTypes from 'prop-types'
import React from 'react'
import styled, { ThemeProvider, css } from 'styled-components'
import Border from '../../Border'
import imageLarge from './stars/starscape-cta-large.svg'
import imageMedium from './stars/starscape-cta-medium.svg'
import imageSmall from './stars/starscape-cta-small.svg'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div`
  position: relative;
  overflow: hidden;
  ${paddingV([2, [3.5, 3], [3.5, 3], [4.5, 3.5]])}

  ${backgroundImageLinearGradient()}

  ${stylesIfPropFalse(
    `showBottomBorder`,
    css`
      ${paddingBottom([2, 4])}
    `
  )}
  
  ${stylesIfPropTrue(
    `showAtXSmallOnly`,
    css`
      ${mq(`smallUp`)} {
        display: none;
      }
    `
  )}
`

const Image = styled.div`
  position: absolute;
  inset: 0;
  background-position: top center;
  background-repeat: no-repeat;
  z-index: 1;

  ${mq(`xSmallOnly`)} {
    background-image: url(${imageSmall});
    background-size: cover;
  }

  ${mq(`smallOnly`)} {
    background-image: url(${imageMedium});
  }

  ${mq(`mediumUp`)} {
    background-image: url(${imageLarge});
    background-position: center bottom;
  }
`

const Content = styled.div`
  position: relative;
  z-index: 2;
  ${constrainNarrow()}
`

const Inner = styled.div`
  overflow: hidden;
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const StarscapeCallToActionBreakoutModule = ({
  children,
  showAtXSmallOnly,
  showBottomBorder,
  topColor,
}) => (
  <ThemeProvider theme={reversedAltTheme}>
    <Layout
      showAtXSmallOnly={showAtXSmallOnly}
      showBottomBorder={showBottomBorder}
      className="Breakout"
    >
      <Inner>
        <ThemeProvider theme={defaultTheme}>
          <React.Fragment>
            <Border edge="top" kind="inset" color={topColor} />
            {showBottomBorder && (
              <Border edge="bottom" kind="inset" color="backgroundStart" />
            )}
          </React.Fragment>
        </ThemeProvider>
        <Image />
        <Content>{children}</Content>
      </Inner>
    </Layout>
  </ThemeProvider>
)

StarscapeCallToActionBreakoutModule.propTypes = {
  children: PropTypes.node.isRequired,
  showAtXSmallOnly: PropTypes.bool,
  topColor: PropTypes.string,
  showBottomBorder: PropTypes.bool,
}

StarscapeCallToActionBreakoutModule.defaultProps = {
  showAtXSmallOnly: false,
  topColor: `backgroundStart`,
  showBottomBorder: true,
}

export default StarscapeCallToActionBreakoutModule
